module.exports = "/images/lines-1.jpg";